export default __webpack_public_path__ + "static/media/mm.02e3ec27.png";